import { io, Socket } from "socket.io-client";

interface SocketClientOptions {
  url: string;
  name: string;
  room: string;
}

interface SendMessageParams {
  action: string;
  customer: Record<string, any>;
  bot: Record<string, any>;
  platform: string;
  dialogList: Array<{
    type: string;
    flow: number;
    content: string;
    status: number;
  }>;
  message_list: Array<{
    type: string;
    content: string;
  }>;
  special: number;
  isFromBoss: number;
}

// type cb = (data: any) => void;

// type CallBack = {
//   connectTimeOut?: () => void;
//   receiveNewMessage?: (msg: any) => void;
//   connectError?: () => void;
//   receiveSendMessage?: (msg: any) => void;
//   receiveReplyNewMessage?: (msg: any) => void;
//   updateDialog?: (msg: any) => void;
//   requestOnlineResume?: (msg: any) => void;
//   acceptAttachResume?: (msg: any) => void;
// };

interface CallBack {
  [key: string]: ((msg: any) => void) | undefined;
  connectTimeOut?: () => void;
  receiveNewMessage?: (msg: any) => void;
  connectError?: () => void;
  receiveSendMessage?: (msg: any) => void;
  receiveReplyNewMessage?: (msg: any) => void;
  updateDialog?: (msg: any) => void;
  requestOnlineResume?: (msg: any) => void;
  acceptAttachResume?: (msg: any) => void;
  routeJoblist?: (msg: any) => void;
  routeRecommend?: (msg: any) => void;
  changeRecommendPosition?: (msg: any) => void;
  checkFilterPanel?: (msg: any) => void;
  addRecommendList?: (msg: any) => void;
  routeToDataRecruit?: (msg: any) => void;
  noticeNoQuota?: (msg: any) => void;
  updateCandidateUser?: (msg: any) => void;
  autoGreetAction?: (msg: any) => void;
  autoGreetLevelAction?: (msg: any) => void;
  autoChatAction?: (msg: any) => void;
}

const socketClient = {
  socketio: null as Socket | null,
  listens: {} as Record<string, CallBack | null>,
  room: "",
  name: "",

  addListener(key: string, back: CallBack): void {
    this.listens[key] = back;
  },

  removeListener(key: string): void {
    this.listens[key] = null;
  },

  connectError() {
    if (this.listens) {
      Object.keys(this.listens).forEach((key) => {
        let back = this.listens[key];
        back && back.connectError && back.connectError();
      });
    }
  },
  // 通知连接超时
  connectTimeOut() {
    if (this.listens) {
      Object.keys(this.listens).forEach((key) => {
        let back = this.listens[key];
        back && back.connectTimeOut && back.connectTimeOut();
      });
    }
  },

  notifyListeners(methodName: string, msg: any) {
    if (this.listens) {
      Object.keys(this.listens).forEach((key) => {
        const listener = this.listens[key];
        if (
          listener &&
          listener[methodName] &&
          typeof listener[methodName] === "function"
        ) {
          listener[methodName]?.(msg);
        }
      });
    }
  },

  // 通知收到的消息
  receiveNewMessage(msg: any) {
    this.notifyListeners("receiveNewMessage", msg);
  },

  // 通知需要发送的消息
  receiveSendMessage(msg: any) {
    this.notifyListeners("receiveSendMessage", msg);
  },

  receiveReplyNewMessage(msg: any) {
    this.notifyListeners("receiveReplyNewMessage", msg);
  },

  initListenMessage(): void {
    console.log("---initListenMessage---");
    const that = this;
    if (this.socketio) {
      this.socketio.on("message", (data) => {
        console.log("receiveSocketMessage", data);
        if (
          [
            "send_message",
            "update_dialog",
            "request_online_resume",
            "accept_attach_resume",
            "route_to_joblist",
            "route_to_recommend",
          ].includes(data.action)
        ) {
        }
        if (data.action === "send_message") {
          that.notifyListeners("receiveSendMessage", data.data);
        } else if (data.action === "update_dialog") {
          that.notifyListeners("updateDialog", data.data);
        } else if (data.action === "request_online_resume") {
          that.notifyListeners("requestOnlineResume", data.data);
        } else if (data.action === "accept_attach_resume") {
          this.notifyListeners("acceptAttachResume", data.data);
        } else if (data.action === "route_to_joblist") {
          this.notifyListeners("routeJoblist", data.data);
        } else if (data.action === "route_to_recommend") {
          this.notifyListeners("routeRecommend", data.data);
        } else if (data.action === "change_recommend_position") {
          this.notifyListeners("changeRecommendPosition", data.data);
        } else if (data.action === "check_filter_panel") {
          this.notifyListeners("checkFilterPanel", data.data);
        } else if (data.action === "add_recommend_list") {
          this.notifyListeners("addRecommendList", data.data);
        } else if (data.action === "route_to_data_recruit") {
          this.notifyListeners("routeToDataRecruit", data.data);
        } else if (data.action === "notice_no_quota") {
          this.notifyListeners("noticeNoQuota", data.data);
        } else if (data.action === "update_candidate_user") {
          this.notifyListeners("updateCandidateUser", data.data);
        } else if (
          data.action === "mx_board_auto_greet_close" ||
          data.action === "mx_board_auto_greet_open"
        ) {
          this.notifyListeners("autoGreetAction", data.action);
        } else if (
          data.action === "mx_board_auto_chat_close" ||
          data.action === "mx_board_auto_chat_open"
        ) {
          this.notifyListeners("autoChatAction", data.action);
        } else if (
          data.action === "mx_board_auto_L3_mode" ||
          data.action === "mx_board_auto_L2_mode"
        ) {
          this.notifyListeners("autoGreetLevelAction", data.action);
        }
      });
    }
  },

  sendClientStatus: function () {
    let that = this;
    if (that.socketio && that.socketio.connected) {
      that.socketio.emit("message", {
        action: "reply_bot_status",
        // room: `wxbot-organization-${that.room}`,
      });
    } else {
      console.log("socket 出错");
      that.setupListeners(() => {
        that.initListenMessage();
      });
    }
  },

  sendMessage: function (data: SendMessageParams) {
    console.log("sendMessage 发送消息", data);
    let that = this;
    that.socketio &&
      that.socketio.emit("message", {
        action: data.action,
        // room: that.room,
        data,
      });
  },

  connect(
    options: SocketClientOptions,
    callback?: () => void,
    successConnect?: () => void
  ): void {
    this.room = options.room;
    this.name = options.name;
    this.socketio = io(options.url, {
      transports: ["websocket"],
    });
    this.setupListeners(callback, successConnect);
  },

  setupListeners(callback?: () => void, successConnect?: () => void): void {
    if (this.socketio) {
      this.socketio.on("connect", () => {
        console.log("----socket连接成功----", "connect", this.room, this.name);
        successConnect && successConnect();
        if (this.socketio) {
          //   this.socketio.emit("login", { user: `[bot]${this.bot_id}` });
          this.socketio.emit("join", { room: this.room, name: this.name });
          this.socketio.emit("join", {
            room: `${this.room}`,
            name: this.name,
          });
        }
      });

      this.socketio.on("disconnect", (reason) => {
        // 断开重连
        console.log("io disconnect", reason, this.socketio);
        // this.socketio && this.socketio.connect();
      });

      this.socketio.on("error", (reason) => {
        // 错误重连
        console.log("io error", reason, this.socketio);
        //   this.connectError();
      });

      this.socketio.on("connect_error", (reason) => {
        console.log("io connect_error error", reason, this.socketio);
        this.connectError();
      });

      this.socketio.on("connect_timeout", (reason) => {
        console.log("io connect_timeout error", reason, this.socketio);
        //   this.setupListeners(callback);
        this.connectTimeOut();
      });

      this.socketio.on("reconnect_error", (reason) => {
        // 错误重连
        console.log("io reconnect_error", reason, this.socketio);
        this.setupListeners(callback);
      });

      this.socketio.on("reconnect_failed", (reason) => {
        // 错误重连
        console.log("io reconnect_failed", reason, this.socketio);
        this.setupListeners(callback);
      });
    }
  },

  emit(event: string, data?: any): void {
    if (this.socketio) {
      this.socketio.emit(event, data);
    }
  },

  disconnect(): void {
    if (this.socketio) {
      this.socketio.close();
      this.socketio = null;
    }
  },
};

export default socketClient;
